<template>

<div class="ltn__shop-details-area pb-85 mt-5">
        <div class="container-fluid w-75">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="ltn__shop-details-inner mb-60">
                        <div class="row">
                            <div class="col-md-6">
                                <img :src="'/upload/'+stok.ambalaj+'.jpg'" />
                            </div>
                            <div class="col-md-6">
                                {{ stok.isim }}
                            <div class="row">
                                <div class="col-12 fw-bold" style="font-size:21px">
                                    <table class=""> 

                                        <tr>
                                        <td class="py-1 text-left">Kod : </td>
                                        <td class="text-left">{{ $helper.ilkharfBuyuk(stok.kod) }}</td>
                                        </tr>  
<tr>
                                        <td class="py-1 text-left">Miktar : </td>
                                        <td class="text-left">{{stok.miktar + ' ' + stok.birim }}</td>
                                        </tr>
                                        <tr>
                                        <td class="py-1 text-left">Net Fiyat : </td>
                                        <td class="pl-2">{{$helper.parabirimi(($helper.kdvlimi((stok.fiyat.iskontolu / $store.getters.getDoviz[hesap.pb]),hesap.kdvli,stok.kdv).kdvli),hesap.pb)}} / {{ stok.birim }}</td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 text-left">Grup : </td>
                                            <td class="pl-2">{{ $helper.ilkharfBuyuk(stok.anagrup) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="py-1 text-left">Marka : </td>
                                            <td class="text-left">{{ $helper.ilkharfBuyuk(stok.marka) }}</td>
                                        </tr>    
                       
                                    </table>                  
                                </div> 
                            </div>
                                <div class="modal-product-info shop-details-info pl-0">

                                    <div class="ltn__product-details-menu-2">
                                        <ul>
                                            <li>
                                                <!-- <div class="cart-plus-minus"><div class="dec qtybutton">-</div>
                                                    <input type="text" value="02" name="qtybutton" class="cart-plus-minus-box">
                                                <div class="inc qtybutton">+</div></div> -->
                                                <select class="form-control" v-model="yeniadet" style="font-size: 21px;min-width: 70px;">
<option v-for="n in (stok.miktar)" :key="n" :value="n">
    {{ n }}
  </option>
                                                </select>
                                            </li>
                                            <li>
                                                / {{ stok.birim }}
                                            </li>                                            
                                            <li>
                                                <a href="javascript:void(0)" @click="sepetekle()" class="theme-btn-1 btn btn-effect-1" title="Add to Cart" data-bs-toggle="modal" data-bs-target="#add_to_cart_modal">
                                                    <i class="fas fa-shopping-cart"></i>
                                                    <span>SEPETE EKLE</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div> 
                                    <hr>  
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                Ürün Bilgisi
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="col-lg-4">
                    <aside class="sidebar ltn__shop-sidebar ltn__right-sidebar">
                        <!-- Top Rated Product Widget -->
                        <div class="widget ltn__top-rated-product-widget">
                            <h4 class="ltn__widget-title ltn__widget-title-border">Alternatif Ürünler</h4>
                            <ul> 
                                <li v-for="(item, index) in varyant" :key="index">
                                    <div class="top-rated-product-item clearfix" :class="{ 'bg-light': isMatched(item.kod) }" @click="changeStok(item)">
                                        <div class="top-rated-product-img">
                                           <img :src="'/upload/'+item.ambalaj+'.jpg'" />
                                        </div>
                                        <div class="top-rated-product-info">
                                            <h6>{{ item.isim }}</h6>
                                            <div class="product-price">
                                                <span class="text-dark">{{$helper.parabirimi(($helper.kdvlimi((item.fiyat.iskontolu / $store.getters.getDoviz[hesap.pb]),hesap.kdvli,stok.kdv).kdvli),hesap.pb)}} / {{ item.birim }}</span>
                                                <span class="text-dark d-block">Eldeki Miktar : {{ item.miktar+ ' '+item.birim }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li> 
                            </ul>
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
  data() {
    return {
      bitti:true,
      yeniadet : 0,
      hesap:this.$store.getters.getHesap,
      //stok:this.$store.getters.getStok.aktif,
      varyant:[], 
            obj:{
        ckod: this.$store.getters.getCari.aktif.kod,
        cari_iskonto_kod:this.$store.getters.getCari.aktif.iskontokod, // iskonto kod değil valet de satis fiyat listeleri sirano
        where: {
          anagrup: 0,
          altgrup: 0,
          marka:0,
          guid: 0,
          kelime: this.$store.getters.searchData.kelime,
          web: 0,
          mevcut:0,
          kampanya: 0,
          yeni: 0,
          //ambalaj:0
          
        },
        gruplama: 0,
        order: {
          key: 'isim',
          value: 'asc'
        },
        sayfa:1,
        sayfalama: 60
      

      },


    };
  },
  computed: { 
    stok(cb){
        return cb.$store.getters.getStok.aktif
    }
  },
  created (){
    this.yeniadet = this.$store.getters.getStok.aktif.sepetadet
    this.getir();
 },
  methods: { 
    getir() {
        this.$store.commit("setLoading",[true,''])
        this.$request.post(this.hesap.program + "/urunDetay/", { extra:{ ambalaj:this.stok.ambalaj, }},this.hesap) .then((res) => {
        this.varyant = res.data
            this.varyant.forEach((e,index) => {
            this.$request.post(this.hesap.program + "/getFiyat/", {extra:{
                fiyat:e.fiyat,
                kampanya:0,//e.kampanya
                kdv:e.kdv,
                ckod : this.obj.ckod,
                cari_iskonto_kod : this.obj.cari_iskonto_kod,
                miktar:e.miktar,
                min:0,//e.min
                kod:e.kod,
                guid:e.id // sepet miktar için
               }},this.hesap)
                .then((res2) => {
                  this.varyant[index].fiyat = res2.data.fiyat;
                  this.varyant[index].durum = res2.data.durum;
                  //this.$store.getters.searchData['s'+this.obj.sayfa][index].adet = 1
                  this.varyant[index].sepetadet = res2.data.sepetadet;

                })
              });
      this.$store.commit("setLoading",[false,''])

      })
    },

    sepetupdate() {
    let source = this.$store.getters.getStok.aktif;
        if (source.miktar>(source.sepetadet+this.yeniadet)) {
      let obje = { giden: this.$helper.point(this.obj.ckod, [], [], [], source.id, '', 1, 0, 0, 0, 'isim', 'asc', 1),adet: this.yeniadet, durum: source.durum }
      this.$request
        .post("basket/update/", obje,this.hesap)
        .then((res2) => {
          if (res2.status == 200) {
              this.$store.commit('updateBasket' , {id:source.id,adet:res2.yeniadet})
            this.$swal.fire({
              position: "top-end",
              icon: "success",
              title: res2.mesaj,
              showConfirmButton: false,
              timer: 1500,
            });
            //this.$store.getters.getStok.aktif = res2.yeniadet;
            this.$store.commit('updateaktifStok' , {alan:'sepetadet',deger:res2.yeniadet})
                        this.yeniadet = res2.yeniadet

          } else if (res2.status == 301) {
            this.$swal({
              title: res2.mesaj,
              text: res2.mesaj2,
              icon: "warning",
              confirmButtonText: "Tamam",
            });
          }
        });
        }
        else {
            this.$swal({
              title: "İzin verilmiyor",
              text: "Miktar yetersiz",
              icon: "warning",
              confirmButtonText: "Tamam",
            });            
        }

    }, 

    sepetekle() {
      let source = this.$store.getters.getStok.aktif;
      let obje = { giden: this.$helper.point(this.obj.ckod, [], [], [], source.id, '', 1, 0, 0, 0, 'isim', 'asc', 1),adet: this.yeniadet, durum: source.durum }
      this.$request
        .post("basket/add/", obje,this.hesap)
        .then((res) => {
            console.log(res)
          if (res.status == 200) {
            //source.sepetadet = 1
            this.$store.commit('updateBasket' , {nerden : res.nerden,data:source})
            this.$swal.fire({
              position: "top-end",
              icon: "success",
              title: res.mesaj,
              showConfirmButton: false,
              timer: 1500,
            });
            this.$store.getters.getCari.aktif.success+1
            source.nerden = res.nerden;
            this.$store.commit('updateaktifStok' , {alan:'sepetadet',deger:res.yeniadet})
            this.yeniadet = res.yeniadet
          } else if (res.status == 302) {
            this.$swal({
              title: res.mesaj,
              text:this.yeniadet + ' adet daha eklensin mi ? ', //res.mesaj2,
              icon: "info",
              showCancelButton: true,
              cancelButtonText: "Hayır",
              confirmButtonText: "Evet",
              //showCloseButton: true,
              //showLoaderOnConfirm: true,
            }).then((result) => {
              if (result.value) {
                this.sepetupdate();
              }
            });
          } else if (res.status == 301) {
            this.$swal({
              title: res.mesaj,
              text: res.mesaj2,
              type: "warning",
              confirmButtonText: "Tamam",
            });
          } else if (res.status == 305) {
            this.$swal.fire({
              position: "top-end",
              type: "warning",
              title: res.mesaj,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            this.$swal({
              title: 'Güvenli Çıkış Yap',
              text: res.mesaj2,
              type: "danger",
              //showCancelButton: true,
              confirmButtonText: "Evet",
              showCloseButton: true,
              showLoaderOnConfirm: true,
              confirmButtonText: "Tamam",
            });
          }
        });
    },

    isMatched(kod) {
        if (this.stok.kod == kod) return true
    },
    changeStok(item) {
        this.yeniadet = item.sepetadet
        this.$store.commit("setLoading",[true,'Ürün Seçiliyor'])
        setTimeout(() => {
          this.$store.commit('addStok' , item)
        this.$store.commit("setLoading",[false,''])       
    }, 500);

    }
  },
};
</script>
<style scoped>
.bg-light{background:rgb(247, 189, 189,.5) !important;}
</style>


// WEBPACK FOOTER //
// src/views/stok/detay.vue